import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
`;

const StyledInputWrapper = styled.div<{ $focus: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 40px;
	padding: 0 12px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid
		${(props) => (props.$focus ? '#2D70DA' : 'rgba(255, 255, 255, 0.1)')};
	border-radius: 8px;
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	cursor: pointer;
	transition: border-color 0.2s ease;

	&:hover {
		border-color: rgba(255, 255, 255, 0.3);
	}
`;

const StyledMultiInputWrapper = styled(StyledInputWrapper)`
	min-height: 40px;
	height: auto;
	padding: 4px 12px;
`;

const StyledArrow = styled.span<{ $active: boolean }>`
	font-size: 10px;
	color: rgba(255, 255, 255, 0.5);
	transform: rotate(${(props) => (props.$active ? '180deg' : '0deg')});
	transition: transform 0.2s ease;
	margin-left: 8px;
`;

const StyledDropdown = styled.div`
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	right: 0;
	background: #1e2023;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 8px;
	z-index: 100;
	overflow: hidden;
`;

const StyledDropdownList = styled.div`
	max-height: 200px;
	overflow-y: auto;

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: rgba(255, 255, 255, 0.05);
	}

	&::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.2);
		border-radius: 3px;
	}
`;

const StyledDropdownItem = styled.div<{
	$selected?: boolean;
	disabled?: boolean;
}>`
	display: flex;
	align-items: center;
	padding: 10px 12px;
	cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
	background: ${(props) =>
		props.$selected ? 'rgba(45, 112, 218, 0.2)' : 'transparent'};
	color: #ffffff;
	transition: background-color 0.15s ease;

	&:hover {
		background: ${(props) =>
			props.disabled ? 'transparent' : 'rgba(255, 255, 255, 0.1)'};
	}
`;

const StyledSearchInput = styled.input`
	width: 100%;
	height: 36px;
	padding: 0 12px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 6px;
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	outline: none;
	box-sizing: border-box;

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
	}

	&:focus {
		border-color: #2d70da;
	}
`;

const StyledSearchWrapper = styled.div`
	padding: 8px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export {
	StyledArrow,
	StyledContainer,
	StyledDropdown,
	StyledDropdownItem,
	StyledDropdownList,
	StyledInputWrapper,
	StyledMultiInputWrapper,
	StyledSearchInput,
	StyledSearchWrapper,
};
